import React from "react"
import PropTypes from "prop-types"
import { get } from "lodash"
import { TextArea } from "@4cplatform/elements/Forms"
import { SmallText } from "@4cplatform/elements/Typography"
import { colours } from "@4cplatform/elements/Helpers"

const MAX_UNDERWRITING_TERMS_LENGTH = 1000

const UnderwritingTermsInput = ({ formik, name, label, ...props }) => {
  const rawValue = get(formik, `values.${name}`, "")
  const value = typeof rawValue === "string" ? rawValue : ""
  const characterCount = value.length
  const hasReachedLimit = characterCount >= MAX_UNDERWRITING_TERMS_LENGTH

  return (
    <>
      <SmallText
        align="right"
        margin="0 0 0.5rem"
        colour={
          hasReachedLimit
            ? get(colours, "red", "red")
            : get(colours, "tints.secondary.darkBlue.t50", "#6f7f8f")
        }
      >
        {`${characterCount}/${MAX_UNDERWRITING_TERMS_LENGTH}`}
      </SmallText>
      <TextArea {...props} formik={formik} name={name} label={label} />
    </>
  )
}

UnderwritingTermsInput.defaultProps = {
  label: "Underwriting terms provided by the insurer"
}

UnderwritingTermsInput.propTypes = {
  formik: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string
}

export default UnderwritingTermsInput
